<template lang="pug">
  #app
    router-view
    Menu
</template>

<script>
import Menu from "@/components/Menu.vue";

export default {
  name: "App",
  components: {
    Menu
  },
  computed: {
    isMobile: {
      get: function() {
        return this.$store.state.isMobile;
      },
      set: function(val) {
        this.$store.state.isMobile = val;
      }
    } 
  },
  mounted() {
    if (window.innerWidth >= 768) {
      this.isMobile = false;
    }
    window.onresize = () => {
      if (window.innerWidth >= 768) this.isMobile = false;
      else this.isMobile = true;
    }
  }
}
</script>

<style lang="scss" src="@/styles.scss">
  
</style>
